var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout-content",attrs:{"noCardStyle":_vm.noCardStyle}},[_c('b-card',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }